import { SubjectProficiency } from '../../requets/shared/model/subject-proficiency.model';

export class SendEvaluationPifle {
  programa: number;
  version: number;
  consecutivo: SubjectProficiency;
  periodo: String;
  nota: String;
  comentario: String;
}
